import Helmet from "react-helmet";
import { Outlet, Route } from "react-router";
import { createGlobalStyle } from "styled-components";

import AppHeader from "../../components/AppHeader";
import ProductEdit from "./ui/pages/ProductEdit";
import ProductExplorer from "./ui/pages/ProductExplorer";
import ProductNew from "./ui/pages/ProductNew";
import { NotificationsProvider } from "../../components/Notifications";

const GlobalStyle = createGlobalStyle`
    :root {
    }
`;

function App() {
    return (
        <NotificationsProvider>
            <Helmet>
                <title>products</title>
            </Helmet>
            <GlobalStyle />
            <AppHeader title="products" />
            <Outlet />
        </NotificationsProvider>
    );
}

export default (
    <Route Component={ App } path="products">
        <Route Component={ ProductExplorer } index />
        <Route path="Product">
            <Route Component={ ProductNew } path="new" />
            <Route Component={ ProductEdit } path=":productID" />
        </Route>
    </Route>
);
